class SylunusAskMax extends HTMLElement {
  connectedCallback() {
    if (document.querySelector('sylunus-ask-max') !== this) { this.remove(); return; }
    if (this.initialized) return;
    this.initialized = true;
    this.button = this.querySelector('.syl-max-launch');
    this.fallback = this.querySelector('.syl-max-fallback');
    this.status = this.querySelector('[data-max-status]');
    this.button.addEventListener('click', () => this.open());
    this.querySelector('.syl-max-dismiss').addEventListener('click', () => {
      this.fallback.hidden = true;
      this.button.focus();
    });
    document.addEventListener('tidioChat-ready', () => this.ready());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.api && this.button.getAttribute('aria-expanded') === 'true') this.api.close();
    });
    this.attach();
  }

  attach() {
    const api = window.tidioChatApi;
    if (!api || this.boundApi === api) return;
    this.boundApi = api;
    api.on('ready', () => this.ready());
    if (typeof api.getStatus === 'function' && api.getStatus() !== null) this.ready();
  }

  ready() {
    const api = window.tidioChatApi;
    if (!api || this.api === api) return;
    this.api = api;
    if (typeof api.adjustStyles === 'function') api.adjustStyles("h2 { white-space: normal !important; overflow: visible !important; text-overflow: clip !important; overflow-wrap: break-word !important; height: auto !important; max-height: none !important; line-height: 1.25 !important; } .chat-header:has(h2) { height: auto !important; min-height: 0 !important; gap: 16px !important; justify-content: flex-start !important; } .chat-header:has(h2) .header-ava { width: 44px !important; height: 44px !important; } .chat-header:has(h2) > :first-child { height: auto !important; min-height: 44px !important; }");
    api.setColorPalette('#333333');
    api.hide();
    api.on('beforeOpen', () => api.setColorPalette('#333333'));
    api.on('open', () => {
      if (!this.requested) { api.hide(); return; }
      this.showOpenState();
    });
    api.on('close', () => {
      api.hide();
      this.requested = false;
      document.documentElement.removeAttribute('data-syl-max-chat-open');
      this.button.hidden = false;
      this.button.setAttribute('aria-expanded', 'false');
      this.button.focus({ preventScroll: true });
    });
    if (this.requested) this.open();
  }

  open() {
    this.attach();
    this.requested = true;
    this.fallback.hidden = true;
    if (!this.api) {
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = this.status.dataset.loading;
      clearTimeout(this.waitTimer);
      this.waitTimer = setTimeout(() => {
        this.requested = false;
        this.button.removeAttribute('aria-busy');
        this.status.textContent = '';
        this.fallback.hidden = false;
      }, 12000);
      return;
    }
    clearTimeout(this.waitTimer);
    this.button.removeAttribute('aria-busy');
    this.status.textContent = '';
    this.api.setColorPalette('#333333');
    this.showOpenState();
    this.api.show();
    this.api.open();
  }

  showOpenState() {
    document.documentElement.setAttribute('data-syl-max-chat-open', '');
    this.button.hidden = true;
    this.button.setAttribute('aria-expanded', 'true');
  }
}

if (!customElements.get('sylunus-ask-max')) customElements.define('sylunus-ask-max', SylunusAskMax);
